import clsx from "clsx";
import { useFormik } from "formik";
import { useEffect } from "react";
import { addBulkLanguage } from "../app/request/languageRequest";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { languages } from "prismjs";
import MultipleCheckBoxSkeleton from "../components/Skeletons/MultipleCheckBox";
import TableView from "../components/TableView";
import Badge from "../components/Badge";
import moment from "moment";
import { initOnLoad } from "apexcharts";
import TableBody from "../components/TableView/TableBody";
import Multiselect from "multiselect-react-dropdown";
import Select from "../components/CustomSelect";
import SelectComponent from "../components/CustomSearchSelect";
import DropBox from "../components/DropBox";
import InputField from "../components/Input";
import CustomCrossButton from "../utils/CustomStyleComponent/CrossButtonComponent";
import CustomArrow from "../utils/CustomStyleComponent/ArrowComponent";
import CustomTooltip from "../utils/CustomStyleComponent/TooltipComponent";
import "./UploadAccessoryForm.css";
import CustomTooltip1 from "../utils/CustomStyleComponent/TooltipNewComponent";
import * as XLSX from "xlsx";

const columns = [
  {
    name: "AccessoryName",
    renderHeader: (rows: any) => (
      <>
        <b>Name</b>
      </>
    ),
    renderCell: (row: any) => <>{row?.accessoryName?.slice(0, 20)}</>,
  },
  {
    name: "Region",
    renderHeader: (rows: any) => (
      <>
        <b>Regions</b>
      </>
    ),
    renderCell: (row: any) => <>{row?.regions?.[`0`]?.regionName}</>,
  },

  {
    name: "status",
    renderHeader: (rows: any) => (
      <>
        <b>Status</b>
      </>
    ),
    renderCell: (row: any) => (
      <Badge
        variant={row?.isAdded == true  ? "success" : "danger"}
        className="fs-7 fw-bolder"
      >
        {row?.isAdded === true 
          ? "Successfully Created/Updated"
          : row?.message || "Not Found,InActive or Duplicate"}



      </Badge>
    ),
  },
];



const findBestMatch = (attributeName: string, headers: string[]) => {
  // Convert attribute name to lowercase for case-insensitive matching
  const attrNameLower = attributeName.toLowerCase();
  
  // First try exact match (case insensitive)
  const exactMatch = headers.find(header => header.toLowerCase() === attrNameLower);
  if (exactMatch) return exactMatch;
  
  // Then try contains match
  const containsMatch = headers.find(header => 
    header.toLowerCase().includes(attrNameLower) || 
    attrNameLower.includes(header.toLowerCase())
  );
  if (containsMatch) return containsMatch;
  
  return null;
}

const UploadResellerAccessoryForm = ({
  category,
  regions,
  handleFileChange,
  setFieldValue,
  values,
  setFieldTouched,
  touched,
  displayUploadResults,
  uploadResults,
  errors,
  headers,
  staticAttributes,
  isloading,
  handleGoBack,
  slideIn,
  slideOut,
}: {
  category: any;
  regions: any;
  displayUploadResults: any;
  uploadResults: any;
  setFieldValue: any;
  values: any;
  isloading: boolean;
  errors: any;
  touched: any;
  setFieldTouched: any;
  handleFileChange: any;
  headers: any;
  staticAttributes: any;
  handleGoBack: () => void;
  slideIn: string;
  slideOut: string;
}) => {
  console.log(uploadResults, "uploadResults");
  console.log(displayUploadResults, "displayUploadResults");

  function useHeaderMapping(headers : any, values :any, staticAttributes : any, setFieldValue : any) {
    useEffect(() => {
      // Force component to recognize this is a new call
      const timerRef = setTimeout(() => {
        if (headers && headers.length > 0) {
          console.log("Mapping effect running with:", {headers, subcategory: values?.subcategory?.[0]});
          
          // Static mapping logic
          const staticMappings = { ...values.staticAttributesMapping || {} };
          staticAttributes.forEach((attribute : any) => {
            const match = findBestMatch(attribute.name, headers);
            if (match) {
              staticMappings[attribute.name] = match;
            }
          });
          
          // Attribute mapping logic
          if (values?.subcategory?.[0]?.supportedAttributes) {
            const attributesMappings = [...(values.attributesMapping || [])];
            const existingMappedAttrs = attributesMappings.map(attr => attr.attributeName);
            
            values.subcategory[0].supportedAttributes.forEach((attribute : any) => {
              if (!existingMappedAttrs.includes(attribute.attributeName)) {
                const match = findBestMatch(attribute.attributeName, headers);
                if (match) {
                  const defaultUnit = attribute.supportedUnits?.[0] || {};
                  attributesMappings.push({
                    attributeName: attribute.attributeName,
                    value: match,
                    unit: {
                      _id: defaultUnit._id,
                      name: defaultUnit.name
                    },
                    translations: attribute.translations
                  });
                }
              } else {
                // For existing mappings, ensure they have the default unit if not already set
                const existingIndex = attributesMappings.findIndex(
                  attr => attr.attributeName === attribute.attributeName
                );
                if (existingIndex !== -1 && !attributesMappings[existingIndex].unit) {
                  const defaultUnit = attribute.supportedUnits?.[0] || {};
                  attributesMappings[existingIndex].unit = {
                    _id: defaultUnit._id,
                    name: defaultUnit.name
                  };
                }
              }
            });
            
            // Set both values with short delay between them
            setFieldValue("staticAttributesMapping", staticMappings);
            setTimeout(() => {
              setFieldValue("attributesMapping", attributesMappings);
            }, 10);
          } else {
            setFieldValue("staticAttributesMapping", staticMappings);
          }
        }
      }, 0);
      
      return () => clearTimeout(timerRef);
    }, [headers, JSON.stringify(values.subcategory), JSON.stringify(staticAttributes)]);
  }

  const generateExcel = () => {
    const wb = XLSX.utils.book_new();
    const wsData = [
      ["modelNumber", "Link", "Price" , "Sku"],
      [
        "ACP076US",
        "https://www.jbhifi.com.au/products/targus-4-port-usb-3-0-hub?queryID=ddd3439094e5104f30f201672a590182&objectID=648144",
        "100",
        "DSU100US"
      ],
      [
        "ACP110US",
        "https://www.jbhifi.com.au/products/targus-dual-travel-usb-3-0-usb-c-dock?queryID=e5819fa7fb74fb0f49a0935c21d41a17&objectID=441217",
        "",
        "",
      ],
      [
        "ACP119US",
        "https://www.jbhifi.com.au/products/targus-chill-mat-with-4-port-hub?queryID=7e5a676578ec1aaeec1700985176bd78&objectID=343703",
        "",
        "",
      ],
    ];
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    // Adjust the column width
    ws['!cols'] = [
        { wch: 20 },
        { wch: 120 },
        { wch: 20 },
        { wch: 20 },
      ];
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "Configuration_upload_template.xlsx";
    link.click();
    URL.revokeObjectURL(url);
  };

  useHeaderMapping(headers, values, staticAttributes, setFieldValue);

  const style = {
    multiSelectContainer: {
      minheight: "44px",
      border: "1px solid var(--bs-gray-100)",
      // styles for the multiselect container
    },
    searchBox: {
      minheight: "44px",
      fontWeight: "500",
      minwidth: "40px",
      maxwidth: "40px",
      height: "44px",
      display: "flex",
      alignItems: "center",
      // styles for the search wrapper
    },
    chips: {
      // To change css chips(Selected options)
      marginBottom: "0",
    },
  };
 

  return (
    <>
      <div className="card p-5 pb-0">
        <div className="container p-0 m-0">
          <div className="row ">
          <div className="col-md-12">
              <div className="justify-content-left">
              <p className="text-danger fs-3 fw-bold">Note: Please don't do bulk upload on prod- Do it /Test first in dev</p>
                <label className="form-label fs-6 fw-bolder text-dark ">
                Sample File
                </label>
                <button className="btn btn-primary ms-5">
                  <a
                    //href="/static-files/Bulk_Upload_Accessory_Standared_Sheet.xlsx"
                    //download
                    onClick={generateExcel}
                    className="text-white"
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mh-50px"><path opacity="0.3" d="M19 15C20.7 15 22 13.7 22 12C22 10.3 20.7 9 19 9C18.9 9 18.9 9 18.8 9C18.9 8.7 19 8.3 19 8C19 6.3 17.7 5 16 5C15.4 5 14.8 5.2 14.3 5.5C13.4 4 11.8 3 10 3C7.2 3 5 5.2 5 8C5 8.3 5 8.7 5.1 9H5C3.3 9 2 10.3 2 12C2 13.7 3.3 15 5 15H19Z" fill="currentColor"></path><path d="M13 17.4V12C13 11.4 12.6 11 12 11C11.4 11 11 11.4 11 12V17.4H13Z" fill="currentColor"></path><path opacity="0.3" d="M8 17.4H16L12.7 20.7C12.3 21.1 11.7 21.1 11.3 20.7L8 17.4Z" fill="currentColor"></path></svg> Download Sample File
                  </a>
                </button>
                <div className="mt-3">
                  <p className="text-primary fs-5 fw-bold">Download the sample template above, share it with the reseller, fill it with the reseller's accessory details, and upload the completed file here.</p>
                </div>
              </div>
            </div>
            <hr></hr>

            <div
              className="col-md-4 p-5 border shadow card "
              style={{ position: "sticky" }}
            >
              <div className="mb-5">
                <label className="form-label fs-6 fw-bolder text-dark required ">
                  Select File
                </label>
                <div>
                  <DropBox
                    onChange={(e: any) => handleFileChange(e)}
                    multiple={false}
                    maxFiles={1}
                  />
                  <input
                    value={values?.files?.[0]?.name}
                    disabled={true}
                    className={clsx("form-control bg-transparent", {
                      "is-invalid":
                        touched?.storeMappedProduct &&
                        errors?.storeMappedProduct,
                    })}
                    type="text"
                  />
                </div>
              </div>
              
              {displayUploadResults && (
                <div
                  className="mt-7 d-flex justify-content-end"
                  onClick={handleGoBack}
                >
                  <span className="btn btn-primary">
                    <i className="fa-solid fa-arrow-left fs-2"></i>
                  </span>
                </div>
              )}
            </div>
            {displayUploadResults ? (
              <div className={`content col-md-8 ${slideIn}`}>
                <div className="d-flex justify-content-center">
                  {uploadResults?.newAccessoriesCount ? <Badge
                    variant="success"
                    className="fs-6 mb-5 me-5 fw-bolder"
                  >
                    {"Successfully Added: "}
                    
                    {uploadResults?.newAccessoriesCount}{" "}
                  </Badge> : ""}
                  
                  {uploadResults?.updatedAccessoriesCount ? <Badge
                    variant="success"
                    className="fs-6 mb-5 me-5 fw-bolder"
                  >
                    {"Successfully Updated: "}
                    {uploadResults?.updatedAccessoriesCount}{" "}
                  </Badge> : ""}
                  
                  <Badge
                    variant="danger"
                    className="fs-6 mb-5 ms-5 fw-bolder"
                  >
                    {"Not Added:"}
                    {uploadResults?.duplicateAccessoriesCount}{" "}{"Duplicate Found"}
                  </Badge>
                </div>
                <TableView
                  rows={uploadResults?.allAccessories || []}
                  columns={columns}
                  showPagination={false}
                  showSearch={false}
                  showPerPage={false}
                  showFilter={false}
                />
              </div>
            ) : (
              <div
                className={`content col-md-8`}
                style={{ maxHeight: "550px", overflowY: "auto" }}
              >
                <div className="col-md-12">
                  <div className="d-flex justify-content-center">
                    <h5 className="fw-bolder mb-5">Specifications</h5>
                  </div>
                  <div className="card p-5 shadow d-flex flex-row flex-wrap mb-3 d-flex">
                    {staticAttributes.map((attribute: any) => {
                      return (
                        <div
                          key={attribute._id || attribute.name}
                          className="row me-2 mb-2"
                          style={{ width: "50%" }}
                        >
                          <div className="w-100px">
                            <label className="col-form-label required fw-bold fs-6">
                              {attribute && attribute.name}
                            </label>
                          </div>

                          <div>
                            <Multiselect
                              options={headers}
                              isObject={false}
                              disable={isloading}
                              selectionLimit={1}
                              style={style}
                              hidePlaceholder={true}
                              customCloseIcon={<CustomCrossButton />}
                              onSelect={async (e) => {
                                let mapping = values.staticAttributesMapping || {};
                                let newobject = {
                                  ...mapping,
                                  [`${attribute.name}`]: e?.[0],
                                };
                                await setFieldValue(
                                  "staticAttributesMapping",
                                  newobject
                                );
                                setFieldTouched("staticAttributesMapping");
                              }}
                              selectedValues={values?.staticAttributesMapping?.[attribute.name] ? 
                                [values.staticAttributesMapping[attribute.name]] : 
                                []
                              }
                              selectedValueDecorator={(
                                value: string,
                                option: any
                              ) => {
                                return (
                                  <CustomTooltip
                                    value={value}
                                    option={option}
                                  />
                                );
                              }}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadResellerAccessoryForm;
